import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { RouterModule, Routes } from '@angular/router';
import { CivMainComponent } from './components/civ-main/civ-main.component';
import { BrowserUtils } from '@azure/msal-browser';
import {MsalGuard} from "@azure/msal-angular";

const routes: Routes = [
  {
    path: '',
    component: CivMainComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'home',
    component: CivMainComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'fe',
    component: CivMainComponent,
    canActivate: [MsalGuard],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation : !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'enabledBlocking'
    })
  ],
  exports: [RouterModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppRoutingModule { }
